import { useLocation, Navigate, Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'

import useAuth from '../hooks/useAuth'
import axios from '../api/axios'

const RequireAuth = () => {
  const { auth, setAuth } = useAuth()
  const location = useLocation()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const impersonationToken = localStorage.getItem("token")

    const loginImpersonatedUser = async () => {
      if (impersonationToken && !auth.user) {
        try {
          const response = await axios.get(`/impersonate-login?token=${impersonationToken.token}&expires_at=${impersonationToken.expires_at}`)
          setAuth((prev) => ({ ...prev, user: response.data.user, token: impersonationToken }))
        } catch (err) {
          console.error("Failed to login impersonated user", err)
        }
      }
      setLoading(false)
    }

    loginImpersonatedUser()
  }, [auth.user, setAuth])

  if (loading) return <div>Loading...</div>

  const isImpersonating = !!localStorage.getItem("token")

  if (!auth.user && !isImpersonating) {
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  const currentUser = auth.user

  const isDependant = !!currentUser?.parent_id

  if (isDependant) {
    const restrictedRoutes = [
      '/my-dependants',
      '/my-school',
      '/book-service/'
    ]

    const currentPath = location.state?.from?.pathname || location.pathname

    if (restrictedRoutes.some(route => currentPath.startsWith(route))) {
      return <Navigate to='/' replace />
    }
  }

  return <Outlet />
}

export default RequireAuth
